import { Component, Input, OnInit } from '@angular/core';
import { ReportTableColumn } from '../../models/report-table-column.model';
import { PlatformService } from '@panamax/app-state';

@Component({
  selector: 'app-report-table',
  templateUrl: './report-table.component.html',
  styleUrls: ['./report-table.component.scss'],
})
export class ReportTableComponent implements OnInit {
  @Input() dataSource: any = [];
  @Input() columnsToDisplay: ReportTableColumn[] = [];

  columnsStrings: string[] = [];

  constructor(public platformService: PlatformService) {}

  ngOnInit() {
    this.columnsStrings = this.columnsToDisplay.map(
      column => column.columnName,
    );
  }
}
